import { render, staticRenderFns } from "./InstitutionSelector.vue?vue&type=template&id=64f48d0f&"
import script from "./InstitutionSelector.vue?vue&type=script&lang=js&"
export * from "./InstitutionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports